import { useId } from 'react';

import { useDraggable } from '@dnd-kit/core';
import { FShallowNode } from '@spazious/dollhouse-shallow-graph';
import { styled } from '@spazious/dollhouse-theme';

export const Card = styled.div`
  border-radius: var(--shape-rounded-radius);
  padding: var(--spazing-padding);
  text-align: center;
  gap: var(--spacing-gap);
`;

export interface DraggableCardProps {
  node: FShallowNode;
  children: React.ReactNode;
}

export const DraggableCard: React.FC<DraggableCardProps> = ({ node, children }) => {
  const { attributes, listeners, setNodeRef } = useDraggable({
    id: useId(),
    data: {
      node,
    },
  });

  return (
    <Card ref={setNodeRef} {...attributes} {...listeners}>
      {children}
    </Card>
  );
};
